import notification from './notification.js'
import rconServer from './rconServer.js'

const handlers = [
  notification,
  rconServer
]

export default handlers
